// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Link-Link-module__Link";
var _2 = "webpack-components-core-Link-Link-module__LinkButton";
var _3 = "webpack-components-core-Link-Link-module__brand";
var _4 = "webpack-components-core-Link-Link-module__neutral";
var _5 = "webpack-components-core-Link-Link-module__primary";
export { _1 as "Link", _2 as "LinkButton", _3 as "brand", _4 as "neutral", _5 as "primary" }
